var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fm-tree"},[_c('div',{staticClass:"fm-tree-disk sticky-top"},[_c('i',{staticClass:"far fa-hdd"}),_vm._v(" "+_vm._s(_vm.selectedDisk)+" ")]),_c('branch',{attrs:{"parent-id":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }